@if (showGraph()) {
<div class="supervisor-dialog-backdrop" (click)="onShowGraphClicked()"></div>
<dialog class="supervisor-dialog-graph" open>
  <div
    style="
      text-align: center;
      margin-bottom: 1rem;
      font-weight: bold;
      color: white;
    "
  >
    <h3>
      Graphs for {{ behavior?.PatientBehaviorName }} ({{
        patientBehaviorTypeLabel(behavior?.BehaviorType)
      }})
    </h3>
  </div>
  <app-behavior-graph
    [patientID]="behavior?.PatientID!.toString()"
    [selectedBehavior]="behavior!"
  ></app-behavior-graph>
</dialog>
} @if (showData()) {
<div class="supervisor-dialog-backdrop" (click)="onShowDataClicked()"></div>
<dialog class="supervisor-dialog" style="max-width: 80rem" open>
  <div
    style="
      text-align: center;
      margin-bottom: 1rem;
      font-weight: bold;
      color: white;
    "
  >
    <h3>Raw Data for {{ behavior?.PatientBehaviorName }}</h3>
  </div>
  <app-rawdata-behavior [selectedBehavior]="behavior!"></app-rawdata-behavior>
</dialog>
} @if (showBIPInfo()) {
<div class="supervisor-dialog-backdrop" (click)="onShowBIPInfoClicked()"></div>
<dialog class="supervisor-dialog" style="max-width: 80rem; color: white" open>
  <app-behavior-bip-info
    [patientID]="behavior?.PatientID!.toString()"
    [selectedBehavior]="behavior!"
    [behaviorID]="behavior?.ID!"
    [startCurrentView]="behavior?.IncludeInCurrentBIP !== false"
    [canEditBip]="behavior?.IncludeInBIP !== false"
  ></app-behavior-bip-info>
</dialog>
} @if (!isExpanded) {
<div
  class="container"
  [style]="{
    border: '2px solid #e1e8fb',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
  [ngClass]="{ 'behavior-selected': isBehaviorSelected() }"
>
  <div
    class="row h-4rem align-items-center justify-content-between"
    [class]="isSelecting ? 'cursor-pointer' : ''"
    (click)="isSelecting ? toggleCollapsed() : null"
  >
    <div class="col-3 d-flex align-items-center">
      <button
        type="button"
        class="btn btn-primary position-relative program-name"
        (click)="!isSelecting ? toggleCollapsed() : null"
        [id]="'toggleCollapseButton-' + behavior?.PatientBehaviorName"
      >
        {{ behavior?.PatientBehaviorName }}
      </button>
    </div>

    @if (behavior?.IsDeleted) {
    <div class="col-1">
      <p-tag id="deleted-tag" severity="danger" value="Deleted" class="ms-2" />
    </div>
    } @if (behavior?.IsArchived) {
    <div class="col-1">
      <p-tag
        id="archived-tag"
        severity="warning"
        value="Archived"
        class="ms-2"
      />
    </div>
    }

    <div class="col-2 d-flex justify-content-end gap-3">
      <i
        class="pi pi-circle-fill"
        style="font-size: 1rem; border: 2px solid white; border-radius: 50%"
        [style.color]="getCircleColor()"
        [style.border-radius]="'50%'"
        [title]="getCircleTooltip()"
      ></i>

      @if(orderMode === 'custom' && isEditMode) { } @else {
      <i
        class="pi pi-arrow-down pointer"
        style="font-size: 1rem; color: #719eb6"
        (click)="!isSelecting ? toggleCollapsed() : null"
      ></i>
      }
    </div>
  </div>
</div>
} @else {
<div
  class="container"
  [style]="{
    border: '2px solid #e1e8fb',
    'border-radius': '10px',
    padding: '5px',
    marginTop: '5px'
  }"
  [ngClass]="{ 'behavior-selected': isBehaviorSelected() }"
>
  <div class="row h-4rem align-items-center justify-content-between">
    <div class="col-3 d-flex align-items-center">
      <button
        type="button"
        class="btn btn-primary position-relative program-name"
        (click)="toggleCollapsed()"
        [id]="'toggleCollapseButton-' + behavior?.PatientBehaviorName"
      >
        {{ behavior?.PatientBehaviorName }}
      </button>
    </div>

    @if (behavior?.IsDeleted) {
    <div class="col-1">
      <p-tag id="deleted-tag" severity="danger" value="Deleted" class="ms-2" />
    </div>
    } @if (behavior?.IsArchived) {
    <div class="col-1">
      <p-tag
        id="archived-tag"
        severity="warning"
        value="Archived"
        class="ms-2"
      />
    </div>
    }

    <div class="col-2 d-flex justify-content-end gap-3">
      <i
        class="pi pi-circle-fill"
        style="font-size: 1rem; border: 2px solid white; border-radius: 50%"
        [style.color]="getCircleColor()"
        [style.border-radius]="'50%'"
        [title]="getCircleTooltip()"
      ></i>

      @if(orderMode === 'custom' && isEditMode) { } @else {
      <i
        class="pi pi-arrow-up pointer"
        style="font-size: 1rem; color: #719eb6"
        (click)="toggleCollapsed()"
      ></i>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-md-9 col-lg-8">
      <div class="row">
        <div class="col-12">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">Behavior Name:</span>
            <span class="text-truncate" style="color: #719eb6">
              {{ behavior?.PatientBehaviorName }}
            </span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="mx-3 my-2">
            <div class="fw-bold" style="color: #719eb6">
              Operational Definition:
            </div>
            <div
              class="mt-2"
              style="color: #719eb6"
              [id]="'operationalDefinition-' + behavior?.ID"
              [innerHTML]="behavior?.OperationalDefinition || 'None'"
            ></div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">Behavior Type:</span>
            <span class="text-truncate" style="color: #719eb6">
              {{ patientBehaviorTypeLabel(behavior?.BehaviorType) }}
            </span>
          </div>
        </div>
      </div>

      @if (shouldDisplayIntervalField()) {
      <div class="row">
        <div class="col-12">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">Interval:</span>
            <span class="text-truncate" style="color: #719eb6">
              {{ secondsToFormattedTime(behavior?.Interval ?? 0) }}
            </span>
          </div>
        </div>
      </div>
      }

      @if (shouldDisplayIntensityScale()) {
      <div class="row">
        <div class="col-12">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">Intensity Scale:</span>
            <span class="text-truncate" style="color: #719eb6">
              {{ intensityScaleDisplay() }}
            </span>
          </div>
        </div>
      </div>
      }

      <div class="row">
        <div class="col-12">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">Date Created:</span>
            <span class="text-truncate" style="color: #719eb6">
              {{ behavior?.DateCreated | date : "MM/dd/yyyy" }}
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">
              Mastered:&nbsp;&nbsp;&nbsp;{{
                behavior?.DateMastered | date : "MM/dd/yyyy"
              }}
            </span>
            <p-checkbox
              id="{{ behavior?.ID + '-mastered' }}"
              [binary]="true"
              [(ngModel)]="isMastered"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="toggleMastery()"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
          >
            <span class="fw-bold" style="color: #719eb6">
              Closed:&nbsp;&nbsp;&nbsp;{{
                behavior?.DateClosed | date : "MM/dd/yyyy"
              }}
            </span>
            <p-checkbox
              id="{{ behavior?.ID + '-closed' }}"
              [binary]="true"
              [(ngModel)]="isClosed"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="toggleClosed()"
            />
          </div>
        </div>
      </div>

      @if(shouldShowAlarmOptions()){
      <div class="row">
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Alarm Option:</span>
            <span class="text-truncate" style="color: #719eb6">{{
              getLabelForAlarmOption(getAlarmOption())
            }}</span>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex justify-content-between align-items-center mx-3">
            <span class="fw-bold" style="color: #719eb6">Alarm Sound:</span>
            <span class="text-truncate" style="color: #719eb6"
              >{{ getAlarmSound() }}
              <i
                class="pi pi-play"
                style="color: #719eb6; cursor: pointer"
                (click)="playAlarmSound()"
              ></i>
            </span>
          </div>
        </div>
      </div>
      }
    </div>

    <div class="col-12 col-md-3 col-lg-4 text-end">
      <div class="d-flex flex-column gap-2">
        <button
          pButton
          class="p-button-outlined side-menu-button2 m-2"
          icon="pi pi-file-excel"
          label="Raw Data"
          (click)="onShowDataClicked()"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        ></button>
        <button
          pButton
          class="p-button-outlined side-menu-button2 m-2"
          icon="pi pi-chart-line"
          label="Graph"
          (click)="onShowGraphClicked()"
        ></button>
        @if (behavior?.IncludeInBIP !== false || behavior?.IncludeInCurrentBIP !== false) {
        <button
          pButton
          class="p-button-outlined side-menu-button2 m-2"
          icon="pi pi-th-large"
          label="BIP Info"
          (click)="onShowBIPInfoClicked()"
        ></button>
        }
      </div>
    </div>
  </div>

  <div class="row" id="behaviorActions">
    <div class="col-12">
      <div
        class="d-flex flex-wrap justify-content-between align-items-center mx-3 my-2"
      >
        <button
          (click)="editBehavior()"
          [id]="'editBehaviorButton-' + behavior?.PatientBehaviorName"
          class="side-menu-button2 flex-grow-1 mx-2"
          [disabled]="behavior?.IsDeleted"
          [style.opacity]="behavior?.IsDeleted ? '0.5' : '1'"
          [style.cursor]="behavior?.IsDeleted ? 'not-allowed' : 'pointer'"
        >
          Edit Behavior
        </button>
        <button
          (click)="showChangeLog()"
          [id]="'changeLogButton-' + behavior?.PatientBehaviorName"
          class="side-menu-button2 flex-grow-1 mx-2"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        >
          <i class="pi pi-history me-1"></i>
          Change Log
        </button>
        @if (!behavior?.IsDeleted && !behavior?.HasData) {
        <button
          (click)="deleteBehavior()"
          [id]="'deleteBehaviorButton-' + behavior?.PatientBehaviorName"
          class="switch-mode-button flex-grow-1 mx-2"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        >
          Delete Behavior
        </button>
        } @if (!behavior?.IsArchived && behavior?.HasData) {
        <button
          (click)="archiveBehavior()"
          [id]="'archiveBehaviorButton-' + behavior?.PatientBehaviorName"
          class="side-menu-button1 flex-grow-1 mx-2"
          [style.opacity]="'1'"
          [style.cursor]="'pointer'"
        >
          Archive Behavior
        </button>
        } @if (behavior?.IsDeleted || behavior?.IsArchived) {
        <button
          (click)="restoreBehavior()"
          [id]="'restoreBehaviorButton-' + behavior?.PatientBehaviorName"
          class="side-menu-button1 flex-grow-1 mx-2"
          [style.opacity]="'1'"
        >
          Restore Behavior
        </button>
        }
      </div>
    </div>
  </div>

  <app-change-log-modal
    #changeLogModal
    [entityID]="behavior?.ID ?? null"
    [entityType]="entityTypeBehavior"
    [entityName]="behavior?.PatientBehaviorName ?? ''"
  ></app-change-log-modal>
</div>
}
